<template>
	<div>
		<action-sidebar
			:title="title"
			:value="true"
			@close-modal="closeModal"
		>
			<user-new-form 
			:user-id="id" 
			:codeProject="codeProject"
			:companyCode="companyCode"/>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import userNewForm from '@/components/users/user-new-form';

function closeModal() {
	this.goTo('page-user');
}

function title() {
	const project = 'Usuario';
	return this.id ? `Editar ${project}` : `Crear ${project}`;
}

export default {
	name: 'page-user-new',
	components: {
		actionSidebar,
		userNewForm,
	},
	computed: {
		title,
	},
	methods: {
		closeModal,
	},
	props: {
		id: {
			type: [Number, String],
		},
		codeProject: {
			type: String,
		},
		companyCode: {
			type: String,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/users/page-user-new.vue